var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-alert",
        {
          staticClass: "intro",
          attrs: { type: "info", closable: false, "show-icon": "" },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("pendingGrants.introTitle"))),
          ]),
          _c("div", { staticClass: "intro-body" }, [
            _vm._v(_vm._s(_vm.$t("pendingGrants.introBody"))),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "160px" },
              on: { change: _vm.fetch },
              model: {
                value: _vm.query.status,
                callback: function ($$v) {
                  _vm.$set(_vm.query, "status", $$v)
                },
                expression: "query.status",
              },
            },
            [
              _c("el-option", {
                attrs: { label: _vm.$t("pendingGrants.statusAll"), value: "" },
              }),
              _c("el-option", {
                attrs: {
                  label: _vm.$t("pendingGrants.status_pending"),
                  value: "pending",
                },
              }),
              _c("el-option", {
                attrs: {
                  label: _vm.$t("pendingGrants.status_claimed"),
                  value: "claimed",
                },
              }),
              _c("el-option", {
                attrs: {
                  label: _vm.$t("pendingGrants.status_cancelled"),
                  value: "cancelled",
                },
              }),
            ],
            1
          ),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "240px" },
            attrs: {
              placeholder: _vm.$t("pendingGrants.searchPlaceholder"),
              clearable: "",
            },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.fetch.apply(null, arguments)
              },
            },
            model: {
              value: _vm.query.search,
              callback: function ($$v) {
                _vm.$set(_vm.query, "search", $$v)
              },
              expression: "query.search",
            },
          }),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: {
                type: "primary",
                icon: "el-icon-search",
                loading: _vm.loading,
              },
              on: { click: _vm.fetch },
            },
            [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { icon: "el-icon-refresh", loading: _vm.sweeping },
              on: { click: _vm.runSweep },
            },
            [_vm._v(" " + _vm._s(_vm.$t("pendingGrants.sweep")) + " ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-plus" },
              on: {
                click: function ($event) {
                  _vm.createVisible = true
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("pendingGrants.addManual")) + " ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { icon: "el-icon-download" },
              on: {
                click: function ($event) {
                  _vm.importVisible = true
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("pendingGrants.importFromCrm")) + " ")]
          ),
        ],
        1
      ),
      _vm.stale.length
        ? _c(
            "div",
            { staticClass: "stale-note" },
            [
              _c(
                "el-alert",
                {
                  attrs: { type: "warning", closable: false, "show-icon": "" },
                },
                [
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("pendingGrants.staleTitle", {
                          n: _vm.stale.length,
                          days: _vm.STALE_DAYS,
                        })
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "intro-body" }, [
                    _vm._v(_vm._s(_vm.$t("pendingGrants.staleBody"))),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.grants,
            border: "",
            fit: "",
            size: "small",
            "row-class-name": _vm.rowClass,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("pendingGrants.email"),
              "min-width": "220",
              prop: "email",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("pendingGrants.feature"),
              "min-width": "170",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("span", { staticClass: "feature" }, [
                      _vm._v(_vm._s(row.featureKey)),
                    ]),
                    _c("div", { staticClass: "sub" }, [
                      _vm._v(_vm._s(_vm.durationLabel(row))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("pendingGrants.source"),
              "min-width": "170",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "mini",
                          type: row.source === "hubspot" ? "warning" : "info",
                        },
                      },
                      [_vm._v(_vm._s(row.source))]
                    ),
                    row.sourceReference
                      ? _c("div", { staticClass: "sub mono" }, [
                          _vm._v(_vm._s(row.sourceReference)),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("pendingGrants.status"),
              "min-width": "190",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.statusTag(row.status),
                          size: "mini",
                          effect: "dark",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("pendingGrants.status_" + row.status)
                            ) +
                            " "
                        ),
                      ]
                    ),
                    row.status === "claimed"
                      ? _c("div", { staticClass: "sub" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDate(row.claimedAt)) +
                              " · " +
                              _vm._s(row.claimedVia) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                    row.status === "cancelled" && row.cancelledReason
                      ? _c("div", { staticClass: "sub" }, [
                          _vm._v(_vm._s(row.cancelledReason)),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("pendingGrants.waiting"),
              width: "110",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.status !== "pending"
                      ? _c("span", { staticClass: "muted" }, [_vm._v("-")])
                      : _c(
                          "span",
                          { class: row.ageDays >= _vm.STALE_DAYS ? "bad" : "" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("pendingGrants.nDays", {
                                    n: row.ageDays,
                                  })
                                ) +
                                " "
                            ),
                          ]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("pendingGrants.actions"),
              width: "200",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.status === "pending"
                      ? [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openAssign(row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("pendingGrants.assign")) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "danger" },
                              on: {
                                click: function ($event) {
                                  return _vm.confirmCancel(row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("pendingGrants.cancel")) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      : row.status === "claimed"
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.confirmCancel(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("pendingGrants.revoke")) + " "
                            ),
                          ]
                        )
                      : _c("span", { staticClass: "muted" }, [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      !_vm.loading && !_vm.grants.length
        ? _c("el-empty", {
            attrs: { description: _vm.$t("pendingGrants.empty") },
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("pendingGrants.assignTitle"),
            visible: _vm.assignVisible,
            width: "560px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.assignVisible = $event
            },
          },
        },
        [
          _vm.assigning
            ? _c(
                "div",
                { staticClass: "assign-body" },
                [
                  _c("p", { staticClass: "intro-body" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("pendingGrants.assignBody", {
                          email: _vm.assigning.email,
                          feature: _vm.assigning.featureKey,
                        })
                      )
                    ),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        remote: "",
                        clearable: "",
                        "reserve-keyword": "",
                        placeholder: _vm.$t(
                          "pendingGrants.userSearchPlaceholder"
                        ),
                        "remote-method": _vm.remoteSearchUsers,
                        loading: _vm.userSearchLoading,
                      },
                      model: {
                        value: _vm.assignUserId,
                        callback: function ($$v) {
                          _vm.assignUserId = $$v
                        },
                        expression: "assignUserId",
                      },
                    },
                    _vm._l(_vm.userOptions, function (u) {
                      return _c("el-option", {
                        key: u.userId,
                        attrs: { label: u.label, value: u.userId },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.assignVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pendingGrants.close")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    disabled: !_vm.assignUserId,
                    loading: _vm.saving,
                  },
                  on: { click: _vm.doAssign },
                },
                [_vm._v(" " + _vm._s(_vm.$t("pendingGrants.assign")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("pendingGrants.addManual"),
            visible: _vm.createVisible,
            width: "560px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.createVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "createForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("pendingGrants.email"),
                    prop: "email",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.form.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("pendingGrants.feature"),
                    prop: "featureKey",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.form.featureKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "featureKey", $$v)
                        },
                        expression: "form.featureKey",
                      },
                    },
                    _vm._l(_vm.features, function (f) {
                      return _c("el-option", {
                        key: f,
                        attrs: { label: f, value: f },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("pendingGrants.durationType"),
                            prop: "durationType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.form.durationType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "durationType", $$v)
                                },
                                expression: "form.durationType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("pendingGrants.years"),
                                  value: "years",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("pendingGrants.months"),
                                  value: "months",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("pendingGrants.days"),
                                  value: "days",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("pendingGrants.permanent"),
                                  value: "permanent",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.form.durationType !== "permanent"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("pendingGrants.durationValue"),
                                prop: "durationValue",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.durationValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "durationValue", $$v)
                                  },
                                  expression: "form.durationValue",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("pendingGrants.notes") } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 2 },
                    model: {
                      value: _vm.form.notes,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "notes", $$v)
                      },
                      expression: "form.notes",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "intro-body" }, [
                _vm._v(_vm._s(_vm.$t("pendingGrants.durationNote"))),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.createVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pendingGrants.close")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.doCreate },
                },
                [_vm._v(_vm._s(_vm.$t("pendingGrants.save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("pendingGrants.importTitle"),
            visible: _vm.importVisible,
            width: "820px",
            top: "6vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.importVisible = $event
            },
          },
        },
        [
          _c(
            "el-alert",
            {
              staticClass: "intro",
              attrs: { type: "warning", closable: false, "show-icon": "" },
            },
            [
              _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                _vm._v(_vm._s(_vm.$t("pendingGrants.importWarnTitle"))),
              ]),
              _c("div", { staticClass: "intro-body" }, [
                _vm._v(_vm._s(_vm.$t("pendingGrants.importWarnBody"))),
              ]),
            ]
          ),
          _c(
            "el-radio-group",
            {
              staticClass: "source-switch",
              attrs: { size: "small" },
              on: {
                change: function ($event) {
                  _vm.importResult = null
                },
              },
              model: {
                value: _vm.importSource,
                callback: function ($$v) {
                  _vm.importSource = $$v
                },
                expression: "importSource",
              },
            },
            [
              _c("el-radio-button", { attrs: { label: "contacts" } }, [
                _vm._v(_vm._s(_vm.$t("pendingGrants.sourceContacts"))),
              ]),
              _c("el-radio-button", { attrs: { label: "deals" } }, [
                _vm._v(_vm._s(_vm.$t("pendingGrants.sourceDeals"))),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "source-note" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    _vm.importSource === "contacts"
                      ? "pendingGrants.contactsNote"
                      : "pendingGrants.dealsNote"
                  )
                ) +
                " "
            ),
          ]),
          _c(
            "div",
            { staticClass: "filter-container" },
            [
              _c(
                "el-select",
                {
                  staticClass: "filter-item",
                  staticStyle: { width: "190px" },
                  model: {
                    value: _vm.importQuery.sinceHours,
                    callback: function ($$v) {
                      _vm.$set(_vm.importQuery, "sinceHours", $$v)
                    },
                    expression: "importQuery.sinceHours",
                  },
                },
                _vm._l(_vm.hourOptions, function (h) {
                  return _c("el-option", {
                    key: h,
                    attrs: {
                      label: _vm.$t("pendingGrants.lastHours", { h: h }),
                      value: h,
                    },
                  })
                }),
                1
              ),
              _c("el-input", {
                staticClass: "filter-item",
                staticStyle: { width: "260px" },
                attrs: {
                  placeholder: _vm.$t(
                    _vm.importSource === "contacts"
                      ? "pendingGrants.emailsPlaceholder"
                      : "pendingGrants.dealIdsPlaceholder"
                  ),
                  clearable: "",
                },
                model: {
                  value: _vm.importQuery.refs,
                  callback: function ($$v) {
                    _vm.$set(_vm.importQuery, "refs", $$v)
                  },
                  expression: "importQuery.refs",
                },
              }),
              _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "primary", loading: _vm.importing },
                  on: {
                    click: function ($event) {
                      return _vm.runImport(false)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("pendingGrants.dryRun")) + " ")]
              ),
              _vm.importResult && _vm.importResult.seen
                ? _c(
                    "el-button",
                    {
                      staticClass: "filter-item",
                      attrs: { type: "warning", loading: _vm.importing },
                      on: { click: _vm.confirmApply },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("pendingGrants.apply")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.importResult
            ? _c("div", { staticClass: "import-summary" }, [
                _vm._v(" " + _vm._s(_vm.importResult.summaryText) + " "),
              ])
            : _vm._e(),
          _vm.importResult
            ? _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.importResult.rows,
                    border: "",
                    fit: "",
                    size: "mini",
                    "max-height": "380",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        _vm.importResult.source === "contacts"
                          ? "pendingGrants.typed"
                          : "pendingGrants.deal"
                      ),
                      "min-width": "190",
                      prop: "label",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("pendingGrants.feature"),
                      "min-width": "170",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              row.features.length
                                ? _c("span", [
                                    _vm._v(_vm._s(row.features.join(", "))),
                                  ])
                                : _c("span", { staticClass: "muted" }, [
                                    _vm._v("-"),
                                  ]),
                              row.unknown.length
                                ? _c("div", { staticClass: "unknown-tokens" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "pendingGrants.unknownTokens",
                                            { tokens: row.unknown.join(", ") }
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3844671877
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("pendingGrants.email"),
                      "min-width": "190",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [_vm._v(_vm._s(row.email || "-"))]
                          },
                        },
                      ],
                      null,
                      false,
                      4182806430
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("pendingGrants.outcome"),
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: _vm.outcomeTag(row.outcome),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.outcomeLabel(row.outcome)))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3137065322
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }